import React, { Component } from 'react';
import AddIcon from '@material-ui/icons/Add';
import SearchSVG from '../../Assets/icons/table-search-icon.svg';
import SortSVG from '../../Assets/icons/table-sort-icon.svg';
import DownloadSVG from '../../Assets/icons/table-download-icon.svg';
import ShareSVG from '../../Assets/icons/table-share-icon.svg';

import PrintSVG from '../../Assets/icons/table-print-icon.svg';
import { withRouter } from 'react-router-dom';
import GetAppIcon from '@material-ui/icons/GetApp';
import { SelectPicker } from 'rsuite';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import "./index.scss"

class KenContainerNavbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            env: JSON.parse(localStorage.getItem('env')),
            email: localStorage.getItem('email'),
            channel: localStorage.getItem('channel'),
            authToken: localStorage.getItem('auth_token'),
            tab: 0,
            containerNav: undefined,
            searchInput: false,
            searchInputValue: "",
            inputShow: false
            // printTimeStamp:''

        }

    }
    printScreen = () => {

        window.print();

    }
    componentWillMount = () => {
        console.log(this.props.containerNav)
        if (this.props.containerNav != undefined) {
            this.setState({ containerNav: this.props.containerNav })
        }
    }
    onSearchClick = () => {
        console.log('search')
        if (this.state.searchInputValue.length == 0) {
            this.setState({ searchInput: !this.state.searchInput })
        }
    }
    searchHandle = (e) => {
        console.log(e.target.value)
        this.setState({ searchInputValue: e.target.value })
        this.props.searchValue(e.target.value)
    }
    onDownload = () => {
        console.log('download event')
        this.props.onDownload()
    }
    onSelectChange = (value, item, event) => {
        console.log(value, item, event)
        this.props.onSelectChange(value, item, event)
    }

    onSelectCampusChange = (value, item, event) => {
        console.log(value, item, event)
        this.props.onSelectCampusChange(value, item, event)
    }
    render() {
        return (<React.Fragment >
            {this.state.containerNav != undefined ? <div className="invoice-page-header container-nav-wrap">
                <div className="header-title">
                    {/* {this.state.containerNav.isBack ? <div className="icon-back-arrow-box"><KeyboardBackspaceIcon className="icon-back-arrow" onClick={() => { this.props.history.goBack() }} /></div> : null} */}
                    <p className="header-txt">{this.state.containerNav.name}
                        <span className="invoices-count-text">{this.state.containerNav.isTotalCount ? (this.state.containerNav.total) : null}</span>
                    </p>
                </div>
                <div className="header-tools">
                    {this.state.containerNav.selectCampusOption ? <div className="pay-receive-header-btns" title="Select duration">
                        <SelectPicker className="SelectPicker-branch" placeholder={this.props.placeholder || "All Campus"} data={this.props.SelectCampusdata} defaultValue={this.props.onSelectCampusDefaultValue} onClean={this.props.onSelectClean} onChange={(value, item, event) => this.onSelectCampusChange(value, item, event)} style={{ width: '200px', marginRight: "10px" }} />
                    </div> : null}
                    {this.state.containerNav.isSelectAppReport ? <div className="pay-receive-header-btns" title="Select">
                        <SelectPicker className="SelectPicker-branch" placeholder={this.props.placeholder || "All Department"} data={this.props.Selectdata} defaultValue={this.props.onSelectDefaultValue} onClean={this.props.onSelectClean} onChange={(value, item, event) => this.onSelectChange(value, item, event)} style={{ width: '200px', marginRight: "10px" }} />
                    </div> : null}

                    {/* {this.state.containerNav.isSearch ? <div className="icon-box" tooltip-title="Search">
                         <SearchIcon className="material-searchIcon" /> 
                        <img src={SearchSVG} alt="Search" className="material-searchIcon" ></img>
                    </div> : null} */}
                    {this.state.containerNav.isSearch ? <div ref={this.searchInputRef} className={(this.state.searchInput) ? "icon-box search-input-wrap" : "icon-box search-icon-wrap"} tooltip-title="Search">

                        {/* <SearchIcon className="material-searchIcon" /> */}
                        {/* <img src={SearchSVG} alt="Search" className="material-searchIcon" ></img> */}
                        {(this.state.searchInput && String(this.state.searchInputValue).length == 0) ?
                            <React.Fragment>
                                <Input
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => this.onSearchClick()}
                                            >
                                                <img src={SearchSVG} alt="Search" className="material-searchIcon" ></img>
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    value={this.state.searchInputValue}
                                    onChange={(e) => this.searchHandle(e)}
                                />
                            </React.Fragment> : (this.state.searchInput && String(this.state.searchInputValue).length > 0) ?
                                <React.Fragment>
                                    <Input
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => this.onSearchClick()}
                                                >
                                                    <img src={SearchSVG} alt="Search" className="material-searchIcon" ></img>
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        value={this.state.searchInputValue}
                                        onChange={(e) => this.searchHandle(e)}
                                    />
                                </React.Fragment> : <img src={SearchSVG} alt="Search" className="material-searchIcon" onClick={() => this.onSearchClick()}></img>}
                    </div> : null}
                    {this.state.containerNav.isSort ? <div className="icon-box" tooltip-title="Filter">
                        {/* <SortIcon className="material-SortIcon" /> */}
                        <img src={SortSVG} alt="Sort" className="material-searchIcon"></img>
                    </div> : null}
                    {this.state.containerNav.isPrint ?
                        <div className="icon-box" tooltip-title="Print" onClick={this.printScreen}>
                            <img src={PrintSVG} alt="Print" className="material-searchIcon" ></img>
                        </div> : null}
                    {this.state.containerNav.isDownload ?
                        <div className="icon-box" tooltip-title={this.state.downloadTitle == undefined ? "Download" : this.state.downloadTitle}>
                            {/* <GetAppIcon className="material-SortIcon" /> */}
                            <img src={DownloadSVG} alt="Download" onClick={() => this.onDownload()} className="material-searchIcon"></img>
                        </div> : null}
                    {this.state.containerNav.isShare ? <div className="icon-box" tooltip-title="Share" style={{ marginRight: this.state.containerNav.isNew ? '10px' : '0px' }}>
                        {/* <ShareIcon className="material-SortIcon" /> */}
                        <img src={ShareSVG} alt="Share" className="material-searchIcon"></img>
                    </div> : null}
                    {this.state.containerNav.isNew ? <div>
                        <button className="add-item-btn" onClick={() => this.props.onAddNew()} tooltip-title={this.state.containerNav.name == "Support" ? 'Create New Ticket' : "Add New " + this.state.containerNav.name} >{!this.state.containerNav.isSubmit ? <AddIcon className="material-addIcon" /> : null}{this.state.containerNav.newName}</button>
                    </div> : null}

                    {this.state.containerNav.isDownloadTemp ? <div>
                        <button className="add-item-btn ctcDownload-btn" onClick={() => this.onDownload()} tooltip-title={"Download"} style={{ width: "162px", marginLeft: "-1px" }}>{!this.state.containerNav.isSubmit ? <GetAppIcon className="material-addIcon" /> : null}{this.state.containerNav.downloadName}</button>
                    </div> : null}
                    {this.state.containerNav.isUpload ? <div>
                        <button className="add-item-btn ctcUpload-btn" onClick={() => this.props.onUpload()} tooltip-title={"Upload"} style={{ width: "auto", marginRight: '5px' }}>{this.state.containerNav.uploadName}</button>
                    </div> : null}
                    {this.state.containerNav.isPayslipBtn ? <div>
                        <button className="add-item-btn" onClick={() => this.props.onSendPayslip()} tooltip-title={"Send Payslip"} >{this.state.containerNav.PayslipBtnName}</button>
                    </div> : null}
                    {this.state.containerNav.isDownloadProcessing ? <div>
                        <button className="add-item-btn approval-btn" onClick={() => this.props.onDownload()} tooltip-title={"Download"} >{this.state.containerNav.dwnldPrcsBtn}</button>
                    </div> : null}




                    {this.state.containerNav.isCreateJV ? <div>
                        <button className="add-item-btn approval-btn" onClick={() => this.props.onCreateJV()} tooltip-title={this.state.containerNav.createJVBtn} >{this.state.containerNav.createJVBtn}</button>
                    </div> : null}
                    {/* <div className="pay-receive-header-btns" style={{ width: '151px' }} title="Date Duration">
                                    <SelectPicker title="Select Duration" className="select-picker-duration" defaultValue={String('all')} placeholder="Select Duration" data={this.state.DateDuration} onChange={this.DurationSelect} />
                                </div> */}
                    {this.state.containerNav.isSelectPeriod ? <div className="pay-receive-header-btns" style={{ width: '151px' }} title="Date Duration">
                        <SelectPicker className="SelectPicker-branch" placeholder="Select Duration" data={this.state.DateDuration} onChange={this.DurationSelect} />
                    </div> : null}
                    {this.state.containerNav.isMasterPayslipName ? <div>
                        <button className="add-item-btn ctcUpload-btn SubmitPayslip" tooltip-title={"Submit Payslip"} onClick={() => this.props.onSubmitPayslip()} >{this.state.containerNav.masterPayslipName}</button>
                    </div> : null}

                </div>
            </div> : null}
        </React.Fragment >);
    }
}

export default withRouter(KenContainerNavbar);